var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7516 16.8613V18.8913C10.7516 20.6113 9.15158 22.0013 7.18158 22.0013C5.21158 22.0013 3.60156 20.6113 3.60156 18.8913V16.8613C3.60156 18.5813 5.20158 19.8013 7.18158 19.8013C9.15158 19.8013 10.7516 18.5713 10.7516 16.8613Z",
    stroke: "#9197B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7503 14.1098C10.7503 14.6098 10.6103 15.0698 10.3703 15.4698C9.7803 16.4398 8.57028 17.0498 7.17028 17.0498C5.77028 17.0498 4.56027 16.4298 3.97027 15.4698C3.73027 15.0698 3.59033 14.6098 3.59033 14.1098C3.59033 13.2498 3.99031 12.4798 4.63031 11.9198C5.28031 11.3498 6.17027 11.0098 7.16027 11.0098C8.15027 11.0098 9.0403 11.3598 9.6903 11.9198C10.3503 12.4698 10.7503 13.2498 10.7503 14.1098Z",
    stroke: "#9197B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7516 14.11V16.86C10.7516 18.58 9.15158 19.8 7.18158 19.8C5.21158 19.8 3.60156 18.57 3.60156 16.86V14.11C3.60156 12.39 5.20158 11 7.18158 11C8.17158 11 9.06161 11.35 9.71161 11.91C10.3516 12.47 10.7516 13.25 10.7516 14.11Z",
    stroke: "#9197B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 10.9692V13.0293C22.0002 13.5793 21.5602 14.0292 21.0002 14.0492H19.0401C17.9601 14.0492 16.9702 13.2592 16.8802 12.1792C16.8202 11.5492 17.0601 10.9592 17.4801 10.5492C17.8501 10.1692 18.3602 9.94922 18.9202 9.94922H21.0002C21.5602 9.96922 22.0002 10.4192 22.0002 10.9692Z",
    stroke: "#9197B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5V8.5C2 5.78 3.64 3.88 6.19 3.56C6.45 3.52 6.72 3.5 7 3.5H16C16.26 3.5 16.51 3.50999 16.75 3.54999C19.33 3.84999 21 5.76 21 8.5V9.95001H18.92C18.36 9.95001 17.85 10.17 17.48 10.55C17.06 10.96 16.82 11.55 16.88 12.18C16.97 13.26 17.96 14.05 19.04 14.05H21V15.5C21 18.5 19 20.5 16 20.5H13.5",
    stroke: "#9197B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenue);
export default __webpack_public_path__ + "static/media/revenue.3636fb7c566b786d7fbeabd6a677a22e.svg";
export { ForwardRef as ReactComponent };